import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import BaseStore from "./BaseStore";
import ActionResultEvents from "../constants/events/ActionResultEvents";

const SESSION_KEY = "Session";
const STORAGE_ENGINE = localStorage;

class SessionState {
    constructor(session) {
        this.session = session;
    }

    isAuthenticated() {
        return this.session.length > 0;
    }

    equals(other) {
        return this.session === other.session;
    }
}

class ImmutableSessionStateBuilder {

    constructor() {
        this.session = STORAGE_ENGINE.getItem(SESSION_KEY) ? STORAGE_ENGINE.getItem(SESSION_KEY) : "";
    }

    setSession(session) {
        this.session = session;
        return this;
    }

    build() {
        return Object.freeze(new SessionState(this.session));
    }
}


class SessionStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.SESSION_STORE_UPDATED, ImmutableSessionStateBuilder);
        this.subscribeToEvent(ActionResultEvents.SESSION_CREATED, this.handleLoginSuccess);
        this.subscribeToEvent(ActionResultEvents.FB_LOGOUT_SUCCESS, this.handleLogoutSuccess);
        this.subscribeToEvent(ActionResultEvents.INVALID_SESSION, this.handleLogoutSuccess);
    }

    handleLoginSuccess = (topic, data) => {
        return new ImmutableSessionStateBuilder()
            .setSession(data.session)
            .build()
    };

    handleLogoutSuccess = (topic, data) => {
        return new ImmutableSessionStateBuilder().setSession("").build();
    };

    setState(newState) {
        super.setState(newState);
        STORAGE_ENGINE.setItem(SESSION_KEY, newState.session);
    }

}

export default new SessionStore();